import nxModule from 'nxModule';
import templateUrl from './batch-loan-payments.template.html';

nxModule.component('batchLoanPayments', {
  templateUrl
});